import { Immutable, toImmutable } from 'nuclear-js';
import CommonValues from 'resources/common-values';

import { StandardTypes } from 'resources/common-values';

export function expandChevrons() {
    const chevrons = document.getElementsByClassName('sub-goal chevron-down');
    for (var i = 0; i < chevrons.length; i++) {
        chevrons[i].className = 'sub-goal chevron-up';
    }

    const statements = document.getElementsByClassName('grouping-container hide-collapse');
    for (i = 0; i < statements.length; i++) {
        statements[i].className = 'grouping-container show-collapse';
    }
}

export function getFilteredLCStatements(statements, groupBy, selectedGoals, strengths, grades, subgoal, grouping) {
    if (!statements || !groupBy || !selectedGoals || !strengths) {
        return null;
    }

    const statementMatchesStrengths = (statement) => {
        return statement.get('strengths')
            ? statement.get('strengths').reduce((acc, nextVal) => {
                  return acc || strengths.contains(nextVal);
              }, false)
            : false;
    };
    const statementMatchesGrades = (statement) => {
        return (
            !(groupBy === CommonValues.INSTRUCTION_AREAS_GROUPBY_STANDARD) || grades.contains(statement.get('grade'))
        );
    };
    const statementMatchesSubgoal = (statement) => {
        return subgoal === 'All' || statement.get('subgoalName') === subgoal;
    };
    const statementMatchesGrouping = (statement) => {
        return grouping === 'All' || statement.get('groupDesc') === grouping;
    };
    const filterStatement = (statement) => {
        const statementMatchesStrengthsYN = statementMatchesStrengths(statement);
        const statementMatchesGradesYN = statementMatchesGrades(statement);
        const statementMatchesSubgoalYN = statementMatchesSubgoal(statement);
        const statementMatchesGroupingYN = statementMatchesGrouping(statement);
        const statementGroupMatchesGroupByYN = statement.get('group') === groupBy;

        return (
            statementMatchesStrengthsYN &&
            statementMatchesGradesYN &&
            statementMatchesSubgoalYN &&
            statementMatchesGroupingYN &&
            statementGroupMatchesGroupByYN
        );
    };

    return statements.filter((s) => filterStatement(s));
}

export function findLCDataForTestEvent(lcData, testEvent) {
    if (!lcData || !testEvent) {
        return null;
    }

    return lcData.get(testEvent.get('testkey'), null);
}
export function fetchGrades(lcData) {
    if (!lcData) {
        return Immutable.List();
    }
    let grades = lcData
        .get('standardGrades')
        .reduce((currentList, val, key) => {
            return currentList.push(
                toImmutable({
                    name: key,
                    displayOrder: val.get('displayOrder'),
                })
            );
        }, Immutable.List())
        .sortBy((g) => g.get('displayOrder'));
    return grades;
}

export function getInstructionalAreaStrength(testScore, testErr, instructionalAreaScore, instructionalAreaErr) {
    const semDiff = Math.sqrt(testErr * testErr + instructionalAreaErr * instructionalAreaErr);
    const ritDiff = instructionalAreaScore - testScore;

    const instructionalAreaStrengthText = {
        weak: {
            text: 'Suggested Area of Focus',
        },
        neutral: {
            text: '',
        },
        strong: {
            text: 'Relative Strength',
        },
    };

    if (ritDiff - semDiff > 0) {
        return instructionalAreaStrengthText['strong'].text;
    } else if (ritDiff + semDiff < 0) {
        return instructionalAreaStrengthText['weak'].text;
    } else {
        return instructionalAreaStrengthText['neutral'].text;
    }
}
export function strengthText(strength, name, ritRange = 'Rit Range Placeholder') {
    const strengthCompare = strength.toLowerCase();

    if (strengthCompare === 'reinforce') {
        return `REINFORCE these skills with ${name} (${ritRange}):`;
    } else if (strengthCompare === 'develop') {
        return `${name} is ready to DEVELOP these skills (${ritRange}):`;
    } else if (strengthCompare === 'introduce') {
        return `Begin to INTRODUCE ${name} to these skills (${ritRange}):`;
    }
    return `INVALID STRENGTH: ${strength}`;
}

export function findRitRanges(instructionalAreaScore) {
    // this method converts the instructional-area score into a set of RIT ranges.  RIT ranges span 10 points
    //    starting from 1 and ending at 0 of the next 10 (for example, 221-230 or 111-120).  Each score gets 3
    //    ranges: reinforce (range immediately below RIT), develop (range containing RIT), and introduce (range
    //    immediately above RIT).  For example, if score is 224:
    //
    //   {
    //       reinforce: { min: 211, max: 220 },
    //       develop: { min: 221, max: 230 },
    //       introduce: { min: 231, max: 240 }
    //   }

    // subtract 1 from score, so that 230 will map to 221-230 insteead of 231-240
    const minDevelop = Math.floor((instructionalAreaScore - 1) / 10) * 10 + 1;
    return {
        reinforce: {
            min: minDevelop - 10,
            max: minDevelop - 1,
        },
        develop: {
            min: minDevelop,
            max: minDevelop + 9,
        },
        introduce: {
            min: minDevelop + 10,
            max: minDevelop + 19,
        },
    };
}

export function findMinMaxRitsForInstructionalArea(instructionalAreaScore) {
    const ritRanges = this.findRitRanges(instructionalAreaScore);
    return {
        min: ritRanges.reinforce.min,
        max: ritRanges.introduce.max,
    };
}

export function sortInstructionalAreas(currentTestEvent) {
    return !currentTestEvent || currentTestEvent.isEmpty()
        ? Immutable.List()
        : currentTestEvent.get('goals', []).sort((g1, g2) => {
              // Sort by RIT then alphanumerically for equal RIT values
              return 1000 * (g1.get('score') - g2.get('score')) + g1.get('name', '').localeCompare(g2.get('name', ''));
          });
}

export function transformLearningStatements(learningStatements, test) {
    // learning statements come in with the following structure:
    //
    //  [
    //          {
    //               goalkey: 101155,
    //               goalName: "Algebraic thinking and operations",
    //               subgoalId: 105133,
    //               subgoalName: "Represent and solve problems",
    //               group: "topic",
    //               groupSortOrder: 8,
    //               groupId: 109,
    //               groupDesc: 'Algebraic Expressions',
    //               lsName: "Evaluates linear expressions at given values",
    //               lsId: 3,
    //               lsSortOrder: 3335,
    //               maxRit: 246,
    //               minRit: 213,
    //               grade: 'Grade1'
    //          }
    //     ]
    //
    // this method will add goal score info, determine the strengths (develop/reinforce/introduce) and
    //     filter out any statements that don't have at least 1 strength
    //
    //     [
    //          {
    //               goalkey: 101155,
    //               goalScore: 224,
    //               goalStandardError: 5.2,
    //               goalName: "Algebraic thinking and operations",
    //               subgoalId: 105133,
    //               subgoalName: "Represent and solve problems",
    //               group: "topic",
    //               groupSortOrder: 8,
    //               groupId: 109,
    //               groupDesc: 'Algebraic Expressions',
    //               lsName: "Evaluates linear expressions at given values",
    //               lsId: 3,
    //               lsSortOrder: 3335,
    //               maxRit: 246,
    //               minRit: 213,
    //               strengths: ['develop', 'reinforce'],
    //               grade: 'Grade1'
    //          }
    //     ]

    if (!learningStatements || !test || !test.get('goals') || learningStatements.size === 0) return toImmutable([]);

    const statementsWithGoalScores = addGoalScoresToStatements(learningStatements, test.get('goals'));
    const statementsWithStrengths = addStrengthsToLearningStatements(statementsWithGoalScores);
    return statementsWithStrengths.filter((s) => !s.get('strengths').isEmpty());
}
export function addGoalScoresToStatements(learningStatements, goals) {
    return learningStatements.map((ls) => {
        const goal = goals.find((g) => g.get('goalkey') === ls.get('goalkey'));
        const score = goal ? goal.get('score') : 0;
        const standardError = goal ? goal.get('standardError') : 0;
        return ls.set('goalScore', score).set('goalStandardError', standardError);
    });
}
export function addStrengthsToLearningStatements(learningStatements) {
    return learningStatements.map((ls) => {
        return ls.set('strengths', findStrengthsForLearningStatement(ls));
    });
}

export function findStrengthsForLearningStatement(learningStatement) {
    const ritRanges = findRitRanges(learningStatement.get('goalScore'));
    let strengths = [];

    // go through each strength and see if there's an overlap between the strengths min/max
    //      and the learningStatement's min/max
    for (let strength in ritRanges) {
        let range = ritRanges[strength];

        // there are 3 checks that are necessary:
        //        1. range min <= ls min <= range max
        //        2. range min <= ls max <= range max
        //        3. ls min < range min and ls max > range max
        const overlapYn =
            (range.min <= learningStatement.get('minRit') && learningStatement.get('minRit') <= range.max) ||
            (range.min <= learningStatement.get('maxRit') && learningStatement.get('maxRit') <= range.max) ||
            (learningStatement.get('minRit') < range.min && learningStatement.get('maxRit') > range.max);

        if (overlapYn) {
            strengths.push(strength);
        }
    }

    return toImmutable(strengths);
}

export const getSelectedGoals = (selectedGoals, testEvent) => {
    if (!selectedGoals || selectedGoals.size === 0) {
        return testEvent ? testEvent.get('goals', Immutable.List()).sortBy((a) => a.get('score')) : Immutable.List();
    } else {
        return selectedGoals;
    }
};

export const getLearningStatementMap = (statements) => {
    if (!statements || statements.isEmpty()) {
        return Immutable.OrderedMap();
    }

    const lsByGoal = statements.sortBy((ls) => ls.get('goalScore')).groupBy((ls) => ls.get('goalkey'));

    const lsBySubgoal = lsByGoal.map((statements, goalkey) => {
        return statements.sortBy((s) => s.get('subgoalName')).groupBy((s) => s.get('subgoalName'));
    });
    const lsByGroup = lsBySubgoal.map((lsForGoals, goalkey) => {
        return lsForGoals.map((lsForSubgoals, subgoalName) => {
            return lsForSubgoals
                .sortBy((sg) => sg.get('lsName'))
                .sortBy((sg) => sg.get('groupDesc'))
                .groupBy((sg) => sg.get('groupDesc'));
        });
    });

    return !lsByGroup ? Immutable.OrderedMap() : lsByGroup;
};

export function sortStrengths(strength1, strength2) {
    if (strength1 === strength2) {
        return 0;
    } else if (strength1 === 'introduce') {
        return 1;
    } else if (strength1 === 'reinforce') {
        return -1;
    } else if (strength2 === 'reinforce') {
        return 1;
    } else {
        return -1;
    }
}

export function defaultGroupBy(standardTypes) {
    // Priority of group by:
    //      topic,
    //      standard,
    //      descartes
    return standardTypes.contains(StandardTypes.topic.storeValue)
        ? StandardTypes.topic.storeValue
        : standardTypes.contains(StandardTypes.standard.storeValue)
        ? StandardTypes.standard.storeValue
        : standardTypes.contains(StandardTypes.descartes.storeValue)
        ? StandardTypes.descartes.storeValue
        : null;
}

export default {
    getFilteredLCStatements,
    getInstructionalAreaStrength,
    sortInstructionalAreas,
    transformLearningStatements,
    addGoalScoresToStatements,
    addStrengthsToLearningStatements,
    findLCDataForTestEvent,
    getSelectedGoals,
    strengthText,
    findMinMaxRitsForInstructionalArea,
    findStrengthsForLearningStatement,
    findRitRanges,
    getLearningStatementMap,
    expandChevrons,
    sortStrengths,
    fetchGrades,
    defaultGroupBy,
};
